import '@tamagui/core/reset.css'

import { useNavigate } from 'react-router-dom'
import { Header } from '../../components/Header'
import { Button, Container, Typography } from '@mui/material'
import { useCurrentUser } from '../../CurrentUser'
import { MyOrganizations } from '../../components/MyOrganizations'

export const Home = () => {
	const navigate = useNavigate()
	const [currentUser, logout] = useCurrentUser()

	return (
		<>
			<Header/>
			<br />
			<Container>
				{currentUser.loggedIn
					?
					<><MyOrganizations /></>
					: <>
						<Typography variant="h2">Welcome to CyTrusted!</Typography>
						<Button fullWidth variant="contained" sx={{ml:'auto', mr:'auto'}} onClick={() => navigate('/login')}>Please log in!</Button>
					</>
				}
			</Container>
		</>
	)
}
